import { useNavigate } from 'react-router-dom';

// This is a singleton to store the navigate function
let navigateFunction = null;

// This hook is used to get and set the navigate function
export const useCustomNavigate = () => {
  const navigate = useNavigate();

  // Store the navigate function for use outside of React components
  navigateFunction = navigate;

  return navigate;
};

// This function can be used outside of React components
export const customNavigate = (to, options) => {
  if (navigateFunction) {
    // In v7, navigate accepts a state option instead of passing it directly
    const { state, ...otherOptions } = options || {};
    navigateFunction(to, { ...otherOptions, state });
  } else {
    console.warn(
      'Navigate function not available yet. Make sure useCustomNavigate is called in a component first.',
    );
    // Fallback to window.location for critical navigation
    window.location.href = to;
  }
};
